<template>
  <div>
    <!-- <page-header :title="$t('bill.summary')">
      <template v-slot:title><currency class="position-absolute" style="right: 0;" /></template>
    </page-header> -->
    <page-body>
      <div class="d-flex mb-3 justify-content-between">
        <div class="d-flex">
          <a-button :disabled="loading" @click="getDatas">
            <a-icon v-if="loading" type="sync" spin />
            <a-icon v-else type="sync" />
          </a-button>
          <a-button @click="openBillReportSubDialog()" type="primary" class="ant-btn ant-btn-default ml-2"><span>{{ $t('bill.report_sub') }}</span></a-button>
          <date-time
            class="ml-2"
            :getParams.sync="dateTime"
            @refresh="getDatas"
            start="start_day"
            end="end_day"
            showStartMonthTip
            paramTimeFormatter="YYYYMMDD" />
        </div>
        <button @click="expandChangeHandle()" type="button" class="ant-btn ant-btn-default ml-2"><a-icon :type="type" /><span>{{title}}</span></button>
      </div>
      <div class="summary-wrapper">
        <a-row>
          <a-col :span="23">
            <div class="d-flex justify-content-between summary"><h2 class="sum">{{$t('bill.text_128')}}：</h2><span class="summary-cost">{{currencySign}} {{summary | currencyFilter}}</span></div>
            <a-collapse v-model="activeKeys">
              <a-collapse-panel class="collapse-1" v-for="sumFirstLv1Obj in summarys" :key="sumFirstLv1Obj.id">
                <div class="header" slot="header"><h3 class="sum-1">{{correctBrand(sumFirstLv1Obj.name)}}</h3><span class="sum-1-cost">{{currencySign}} {{sumFirstLv1Obj.cost | currencyFilter}}</span></div>
                <a-collapse v-model="active2Keys">
                  <a-collapse-panel class="collapse-2" v-for="sumFirstLv2Obj in sumFirstLv1Obj.nodes" :key="sumFirstLv2Obj.id">
                    <div class="header" slot="header"><h4 class="sum-2">{{correctAccount(sumFirstLv2Obj.name)}}</h4><span class="sum-2-cost">{{currencySign}} {{sumFirstLv2Obj.cost | currencyFilter}}</span></div>
                    <a-collapse v-model="active3Keys">
                      <a-collapse-panel class="collapse-3" v-for="sumFirstLv3Obj in sumFirstLv2Obj.nodes" :key="sumFirstLv3Obj.id">
                        <div class="header" slot="header"><h5 class="sum-3">{{sumFirstLv3Obj.name}}</h5><span class="sum-3-cost">{{currencySign}} {{sumFirstLv3Obj.cost | currencyFilter}}</span></div>
                        <a-collapse v-model="active4Keys">
                          <a-collapse-panel class="collapse-4" v-for="sumFirstLv4Obj in sumFirstLv3Obj.nodes" :key="sumFirstLv4Obj.id">
                            <div class="header" slot="header"><h6 class="sum-4">{{getBillResourceTypeLabel(sumFirstLv4Obj.name)}}</h6><span class="sum-4-cost">{{currencySign}} {{sumFirstLv4Obj.cost | currencyFilter}}</span></div>
                            <div class="res-content">
                              <a-row :gutter="[6,6]" v-for="sumFirstLv5Obj in sumFirstLv4Obj.nodes" :key="sumFirstLv5Obj.name">
                                <a-col class="text-left" :span="8">{{sumFirstLv5Obj.name}}</a-col>
                                <a-col class="text-left" :span="8">{{CHARGE_TYPE[sumFirstLv5Obj.charge_type]}}</a-col>
                                <a-col :span="8">{{currencySign}} {{sumFirstLv5Obj.cost | currencyFilter}}</a-col>
                              </a-row>
                            </div>
                          </a-collapse-panel>
                        </a-collapse>
                      </a-collapse-panel>
                    </a-collapse>
                  </a-collapse-panel>
                </a-collapse>
              </a-collapse-panel>
            </a-collapse>
          </a-col>
        </a-row>
      </div>
    </page-body>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { TIME_SIZE, CHARGE_TYPE } from '@Bill/constants'
import currencyMixin from '@Bill/mixins/currency'
import currencyRequest from '@Bill/mixins/currencyRequest'
import WindowsMixin from '@/mixins/windows'
import { currencyUnitMap } from '@/constants/currency'
import { numerify } from '@/filters'
import setting from '@/config/setting'
import { getBillResourceTypeLabel } from '@Bill/utils'

export default {
  name: 'BillReports',
  components: {
  },
  filters: {
    currencyFilter: (value) => {
      if (value === undefined) return ''
      return numerify(value, '0,0.00')
    },
  },
  mixins: [currencyMixin, WindowsMixin, currencyRequest],
  props: {
    billShared: Boolean,
    projectShared: Boolean,
  },
  data () {
    return {
      CHARGE_TYPE,
      loading: false,
      dateTime: this.getDate(),
      summary: 0,
      summarys: [],
      isExpand: false,
      activeKeysTemp: [],
      active2KeysTemp: [],
      active3KeysTemp: [],
      activeKeys: [],
      active2Keys: [],
      active3Keys: [],
    }
  },
  computed: {
    ...mapGetters(['isAdminMode', 'scope']),
    ...mapState('common', {
      currency: state => state.bill.currency,
    }),
    currencySign () {
      return currencyUnitMap[this.currency]?.sign || '$'
    },
    type () {
      return this.isExpand ? 'minus' : 'plus'
    },
    title () {
      return !this.isExpand ? this.$t('bill.summary_expand_all') : this.$t('bill.summary_collapse_all')
    },
  },
  watch: {
    currency () {
      this.getDatas()
    },
    billShared () {
      this.getDatas()
    },
    projectShared () {
      this.getDatas()
    },
  },
  created () {
    this.analysisM = new this.$Manager('bill_analysises/summary', 'v1')
    this.getDatas()
  },
  methods: {
    getBillResourceTypeLabel,
    changeActivekey (key) {
      console.log(key)
    },
    getDate () {
      const end = this.$moment()
      const start = this.$moment().startOf('month')
      return {
        start_date: start.format('YYYY-MM-DD') + 'TZ',
        end_date: end.format('YYYY-MM-DD') + 'TZ',
        data_type: TIME_SIZE.month,
      }
    },
    async getDatas () {
      this.isExpand = false
      this.loading = true
      try {
        const params = {
          query_type: 'summary',
          platform_brand: this.activeTab,
          ...this.dateTime,
          start_date: this.$moment(this.dateTime.start_day).format('YYYY-MM-DD') + 'TZ',
          end_date: this.$moment(this.dateTime.end_day).format('YYYY-MM-DD') + 'TZ',
          admin: this.isAdminMode,
          scope: this.scope,
          ...this.currencyParams,
        }
        if (this.billShared) {
          params.is_prepaid_amortizing = true
        } else {
          params.is_prepaid_amortizing = false
        }
        if (this.projectShared) {
          params.is_project_sharing = true
        } else {
          params.is_project_sharing = false
        }
        const { data } = await this.analysisM.list({ params: params })
        this.summarys = data.details
        this.initActiveKeys(data.details)
        this.summary = data.total_amount
        this.loading = false
      } catch (error) {
        this.loading = false
        throw error
      }
    },
    openBillReportSubDialog () {
      this.$router.push('/billsummary/subscriptioncreate')
    },
    initActiveKeys (summarys = []) {
      this.activeKeysTemp = []
      this.active2KeysTemp = []
      this.active3KeysTemp = []

      summarys.forEach(v1 => {
        this.activeKeysTemp.push(v1.id)
        if (v1.nodes) {
          v1.nodes.forEach(v2 => {
            this.active2KeysTemp.push(v2.id)
            if (v2.nodes) {
              v2.nodes.forEach(v3 => {
                this.active3KeysTemp.push(v3.id)
              })
            }
          })
        }
      })
    },
    expandChangeHandle () {
      this.isExpand = !this.isExpand
      if (this.isExpand) {
        this.active3Keys = this.active3KeysTemp
        this.active2Keys = this.active2KeysTemp
        this.activeKeys = this.activeKeysTemp
      } else {
        this.activeKeys = []
        this.active2Keys = []
        this.active3Keys = []
      }
    },
    correctBrand (brand) {
      if (brand === 'OneCloud' || brand === 'OneStack') {
        const oemBrand = setting.brand[this.$store.getters.setting.language]
        return oemBrand || brand
      }
      return brand
    },
    correctAccount (account) {
      if (account === 'OneStack') {
        const oemBrand = setting.brand.en
        return oemBrand || account
      }
      return account
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/scss/index';

.summary-wrapper{
  ::v-deep {
    .sum{
      font-size: 20px;
      padding: 8px 0px 0;
    }
    .sum-1{
      font-size: 18px;
    }
    .sum-2{
      font-size: 16px;
    }
    .sum-3{
      font-size: 14px;
    }
    .sum-4{
      font-size: 14px;
    }
    .res-content{
      width: 100%;
      padding-left: 62px;
      text-align: right;
    }
    .header{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .summary{
      border-bottom: 1px solid #ccc;;
    }
    .summary-cost{
      font-size: 20px;
      font-weight: bold;
      padding: 8px 0px 0;
      color: rgba(0, 0, 0, 0.85);
    }
    .sum-1-cost{
      font-size: 18px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
    }
    .sum-2-cost{
      font-weight: bold;
    }
    .ant-collapse{
      margin-left: 10px;
      background: #fff;
      .header{
        border-bottom: 1px solid #ccc;
      }
    }
    .collapse-2 {
      margin-left: 20px;
      .header{
        border-bottom: 1px solid #ccc;
      }
    }
    .collapse-3 {
      margin-left: 30px;
      .header{
        border-bottom: 1px solid #ccc;
      }
    }
    .collapse-4 {
      margin-left: 20px;
      .header{
        border-bottom: 1px solid #ccc;
      }
    }
    .ant-collapse .ant-collapse-item .ant-collapse-header{
      color: #000;
    }
    .ant-collapse > .ant-collapse-item > .ant-collapse-header,
    .ant-collapse > .ant-collapse-item > .ant-collapse-header{
      padding: 5px 0px;
      padding-left: 40px;
    }
    .ant-collapse-content > .ant-collapse-content-box{
      padding: 4px 0px;
    }
    .ant-collapse-content{
      padding: 3px 0px;
      border-top: none;
    }
  }
}
</style>
